var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuillProductsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7db9bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#3584bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#355cbc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.62683,46.97089c.63641-1.6369,1.5459-3.09259,1.72797-4.82056-4.00208.90869-7.27673,3.36487-10.27917,6.36896,0,1.27362-.091,2.54639-.18207,3.82001-.45428-.54535-.72742-1.27277-1.09155-1.81897-.09021.18207-.27222-.09021-.36328,0-1.09155,1.5459-1.91003,3.27466-2.45618,5.09363-.90955,2.91138-1.81903,5.82111-1.63696,9.09576.18127,1.63776,2.00104,2.54724,2.81952,4.00208.5462,2.0011.81927,4.185,1.54669,6.18604.09021-.27393-.091-.45428,0-.63721.18207.27307.09106.63641.27313.81927,0-.72906-.18207-1.72961.5462-2.00104-.18207-1.6394-.5462-3.27466-.5462-4.91241,1.00049-1.36627,2.45618-2.63824,3.63794-3.91187.81934-1.18341.63727-2.82037.63727-4.27521-.90955,0-1.81903.27307-2.63831.36328.81927-.72742,1.81982-1.45483,2.72931-2.1839.54535-1.4549.81848-3.0918,1.5459-4.45642.45514-.90955.90948-1.91003,1.36462-2.81952-.54535-.27393-1.27277-.36414-1.72791-.63721,1.00049-.4552,2.09204-.81848,3.09259-1.27362l1.00049-2.0011Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.93835,34.38452l-5.6098-3.23883-18.48676,10.67346,6.79382,3.92236c.36646.21155.81793.21155,1.18439,0l16.11835-9.3056c.78961-.45587.78961-1.59552,0-2.05139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.63586,25.07874l-16.11823,9.30585c-.78955.45587-.78955,1.59552.00006,2.05139l5.13184,2.96283,18.48712-10.67334-6.31641-3.64673c-.36646-.21155-.81793-.21155-1.18439,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.6452,41.03442v18.68835c0,.41119.21942.7912.57556.99683l16.18445,9.34412c.76733.44299,1.72656-.11078,1.72656-.99683v-18.68817c0-.41125-.21942-.7912-.5755-.99683l-6.87177-3.96747v9.87964l-4.19214-2.17682v-10.12323l-5.12061-2.95642c-.76733-.44299-1.72656.11078-1.72656.99683Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuillProductsScraper);
export default __webpack_public_path__ + "static/media/quill-products-scraper.d6e4ed1a7f849eeeea993327ae3135e4.svg";
export { ForwardRef as ReactComponent };